(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["led-flex-mask-landing"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-led-guarantee-link]');
  if (!link) return;
  const details = document.getElementById(link.hash.slice(1));
  if (details && details.tagName === 'DETAILS') details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-flex-mask-product"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-led-guarantee-link]');
  if (!link) return;
  const details = document.getElementById(link.hash.slice(1));
  if (details && details.tagName === 'DETAILS') details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wr-meta-led-product"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-led-guarantee-link]');
  if (!link) return;
  const details = document.getElementById(link.hash.slice(1));
  if (details && details.tagName === 'DETAILS') details.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
